import { Box, BoxProps } from "@mui/material";

// name: "StyledEquipmentItemBox"
export const StyledItemBox: React.FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box sx={{ marginRight: "20px", marginTop: "20px", width: "100%", ...sx }} {...rest}>
    {children}
  </Box>
);
